import { FC, useEffect, useState } from "react";
import { EnumSingleSelectFieldV2 } from "../../Fields/";
import { Option } from "../../Fields/types/fieldTypes";
import { EnumSingleSelectFieldValue } from "../../Fields/types/fieldTypes";
import classNames from "classnames";
import GridViewOption from "../PrimaryGrid/modules/GridViews/types/GridViewOption";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from "@fortawesome/free-solid-svg-icons";

interface GridViewsSingleSelectProps {
  label?: string;
  gridViewOptions: GridViewOption[];
  value: EnumSingleSelectFieldValue;
  showUserDefaultView?: boolean;
  setDefaultView?: (id: string) => Promise<void>;
  onSubmit: (value: EnumSingleSelectFieldValue) => void;
}

const GridViewsSingleSelect: FC<GridViewsSingleSelectProps> = (
  props: GridViewsSingleSelectProps
) => {
  const [localValue, setLocalValue] = useState<EnumSingleSelectFieldValue>(
    props.value
  );

  useEffect(() => {
    setLocalValue(props.value);
  }, [props.value]);

  const itemTemplate = (option: Option<string>): React.ReactNode => {
    const isDefault = props.gridViewOptions.some(
      (o) => o.value === option.value && o.isDefault
    );
    return (
      <div className="ucl-grid-view-option">
        <span>{option.label}</span>
        {props.showUserDefaultView && (
          <FontAwesomeIcon
            className={classNames("ucl-grid-view-favorite-icon", {
              "ucl-grid-view-favorite-icon-selected": isDefault,
            })}
            icon={faStar}
            onClick={() => {
              if (!isDefault) {
                props.setDefaultView && props.setDefaultView(option.value);
              }
            }}
          />
        )}
      </div>
    );
  };

  return (
    <div className="ucl-grid-views-single-select">
      <EnumSingleSelectFieldV2
        key={JSON.stringify(props.gridViewOptions)}
        type={"EnumSingleSelect"}
        label={props.label || "Views"}
        showClearButton={false}
        allowFiltering={false}
        optionValues={props.gridViewOptions}
        itemTemplate={itemTemplate}
        value={localValue}
        onSubmit={(value) => {
          setLocalValue(value);
          props.onSubmit(value);
        }}
      />
    </div>
  );
};

export default GridViewsSingleSelect;
